const sexes = [
  { key: 'male', value: 'Male' },
  { key: 'female', value: 'Female' }
];

const ages = [
  { key: '18_24', value: '18-24' },
  { key: '25_40', value: '25-40' },
  { key: '40_55', value: '40-55' },
  { key: 'more_than_55', value: 'Over 55' }
];

const education = [
  { key: 'some_high_school', value: 'Some High School' },
  { key: 'high_school', value: 'High School' },
  { key: 'some_college', value: 'Some College' },
  { key: 'college', value: 'College' },
  { key: 'post_graduate', value: 'Post-Graduate' }

];

const composition = [
  { key: '0', value: 'No children' },
  { key: '1', value: '1 child' },
  { key: '2_4', value: '2 - 4 children' },
  { key: 'more_than_4', value: 'Over 4 children' }
];

const income = [
  { key: 'less_than_20', value: '< $20,000' },
  { key: '20_50', value: '$20,000 - $50,000' },
  { key: '50_100', value: '$50,000 - $100,000' },
  { key: 'more_than_100', value: '> $100,000' }
];

const races = [
  'Other',
  'White',
  'Hispanic',
  'African American',
  'Asian American'
];

/* eslint-disable import/prefer-default-export */
export const metrics = {
  sexes,
  ages,
  education,
  composition,
  income,
  races
};



// WEBPACK FOOTER //
// ./src/assets/data/demographics/index.js